module.exports = "/shared/fonts/Futura/FtraHv.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/Futura/FtraHv.ttf
// module id = 31
// module chunks = 13